import * as type from '../actions/types';

const initialState = {

    loading: false,
    error: null,
    buyPtojectsData: {},
}

export default function buyPtojects(state = initialState, action) {
    switch (action.type) {
        case type.GET_ALL_BUY_PROJECTS_DATA_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_ALL_BUY_PROJECTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                buyPtojectsData: action.data
            }
        case type.GET_ALL_BUY_PROJECTS_DATA_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}